import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useClientTenantStore } from '../../../../store/clientTenantStore';
import { useBookingFlowStore } from '../../../../store/bookingFlowStore';
import { SectionCard } from '../../../../components/client/ui/SectionCard';
import { SpecialistCard } from './SpecialistCard';
import { useHomeStrings } from '../../hooks/useHomeStrings';

export const SpecialistsSection: React.FC = () => {
  const STRINGS = useHomeStrings();
  const navigate = useNavigate();
  const providers = useClientTenantStore((s) => s.providers);
  const providerCount = useClientTenantStore((s) => s.providerCount);
  const setProvider = useBookingFlowStore((s) => s.setProvider);
  const resetFlow = useBookingFlowStore((s) => s.resetFlow);

  const handleSelect = useCallback(
    (id: number, displayName: string) => {
      resetFlow();
      setProvider(id, displayName);
      navigate('/booking/new/1');
    },
    [resetFlow, setProvider, navigate],
  );

  if (providerCount < 2) return null;

  const activeProviders = providers.filter((p) => p.active);
  if (activeProviders.length === 0) return null;

  return (
    <SectionCard title={STRINGS.SPECIALISTS_TITLE}>
      <div
        className="bl-hide-scrollbar"
        style={{
          display: 'flex',
          overflowX: 'auto',
          gap: 4,
          paddingBottom: 4,
        }}
      >
        {activeProviders.map((p) => (
          <SpecialistCard
            key={p.id}
            id={p.id}
            displayName={p.displayName}
            photoUrl={p.photoUrl}
            bio={p.bio}
            onClick={handleSelect}
          />
        ))}
      </div>
    </SectionCard>
  );
};
